import { useSearchParams, useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentFailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = searchParams.get('code');
  const message = searchParams.get('message');

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <XCircle className="w-8 h-8 text-red-500" />
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">결제에 실패했습니다</h2>
        <p className="text-gray-600 mb-2">
          {message || '결제 처리 중 오류가 발생했습니다.'}
        </p>
        {code && (
          <p className="text-sm text-gray-400 mb-6">오류 코드: {code}</p>
        )}
        <div className="space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="w-full px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90"
          >
            다시 시도하기
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            홈으로 돌아가기
          </button>
        </div>
      </div>
    </div>
  );
}
